/** CUIT: normalización, formato y aviso del dígito verificador (algoritmo AFIP). */
const WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
const VALID_PREFIXES = ['20', '23', '24', '25', '26', '27', '30', '33', '34', '50', '51', '55'];

export const normalizeCuit = (v) => String(v ?? '').replace(/\D/g, '');

export const formatCuit = (v) => {
  const n = normalizeCuit(v);
  return n.length === 11 ? `${n.slice(0, 2)}-${n.slice(2, 10)}-${n[10]}` : String(v ?? '').trim();
};

export const cuitCheckDigitOk = (v) => {
  const n = normalizeCuit(v);
  if (n.length !== 11) return false;
  const total = WEIGHTS.reduce((acc, w, i) => acc + Number(n[i]) * w, 0);
  const rest = total % 11;
  const expected = rest === 0 ? 0 : rest === 1 ? 9 : 11 - rest;
  return expected === Number(n[10]);
};

/** Texto del aviso (o null si está bien). Nunca bloquea el guardado. */
export const cuitWarning = (v) => {
  const n = normalizeCuit(v);
  if (!n) return null;
  if (n.length !== 11) return `Tiene ${n.length} dígitos en lugar de 11: revisalo.`;
  if (!VALID_PREFIXES.includes(n.slice(0, 2))) return `Empieza con ${n.slice(0, 2)}, que no es un prefijo habitual: revisalo.`;
  if (!cuitCheckDigitOk(n)) return 'El dígito verificador no cierra: revisalo (se puede guardar igual).';
  return null;
};
